export const tec = {
    agencyCode: '356',
    name: 'Texas Ethics Commission',
    shortName: 'TEC',
    slug: 'tec',
  };
  